import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { QuickBooksObjectDataset } from 'app/model/dataset/quick-books.dataset';
import { QuickBooksLinkedService } from 'app/model/linkedservice/quick-books.linkedservice';
import { format } from 'app/shared/utils/string.util';

export const quickBooksObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(QuickBooksObjectDataset).name,
    displayName: stringResources.QuickBooks_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(QuickBooksLinkedService).name],
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
        stringResources.VersionLabel.toLocaleLowerCase()
    ),
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-quickbooks'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
